
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { SupportTicketUploadPermissionDto } from '@/services/api-clients';

@Component
export default class SupportTicketMessageInput extends Vue {
  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  @Prop({ type: Object, default: null }) uploadPermission!: SupportTicketUploadPermissionDto | null;

  // Only the employee assigned to the ticket may grant or end a permission, like replying.
  @Prop({ type: Boolean, default: false }) canManageFiles!: boolean;

  @Prop({ type: Boolean, default: false }) permissionSaving!: boolean;

  content = '';

  sending = false;

  permissionMenu = false;

  maxFiles = 1;

  maxFilesOptions = [1, 2, 3, 4, 5];

  get canSend(): boolean {
    return this.content.trim().length > 0 && this.content.length <= 2000;
  }

  @Emit('send')
  emitSend(value: string): string {
    return value;
  }

  // No payload and no throttling here; the parent knows the ticket id and limits the rate.
  @Emit('typing')
  emitTyping(): void {
    return undefined;
  }

  @Emit('grant-permission')
  emitGrantPermission(maxFiles: number): number {
    return maxFiles;
  }

  @Emit('end-permission')
  emitEndPermission(): void {
    return undefined;
  }

  // Like send, the menu resets right away; the parent calls the server and shows any error.
  grantPermission() {
    this.emitGrantPermission(this.maxFiles);
    this.permissionMenu = false;
    this.maxFiles = 1;
  }

  onEnter() {
    if (this.canSend && !this.disabled) {
      this.send();
    }
  }

  async send() {
    if (!this.canSend || this.disabled) return;
    this.sending = true;
    const toSend = this.content.trim();
    this.emitSend(toSend);
    this.content = '';
    this.sending = false;
  }
}
